/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Unit_Audio_Minute_PerInputs */

const en_measure_unit_audio_minute_per = /** @type {(inputs: Measure_Unit_Audio_Minute_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per audio minute`)
};

const zh_hans1_measure_unit_audio_minute_per = /** @type {(inputs: Measure_Unit_Audio_Minute_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每分钟音频`)
};

const pt_br2_measure_unit_audio_minute_per = /** @type {(inputs: Measure_Unit_Audio_Minute_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por minuto de áudio`)
};

const es_measure_unit_audio_minute_per = /** @type {(inputs: Measure_Unit_Audio_Minute_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por minuto de audio`)
};

const fr_measure_unit_audio_minute_per = /** @type {(inputs: Measure_Unit_Audio_Minute_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par minute audio`)
};

const de_measure_unit_audio_minute_per = /** @type {(inputs: Measure_Unit_Audio_Minute_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro Audiominute`)
};

const ru_measure_unit_audio_minute_per = /** @type {(inputs: Measure_Unit_Audio_Minute_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`за минуту аудио`)
};

const it_measure_unit_audio_minute_per = /** @type {(inputs: Measure_Unit_Audio_Minute_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per minuto di audio`)
};

/**
* | output |
* | --- |
* | "per audio minute" |
*
* @param {Measure_Unit_Audio_Minute_PerInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_unit_audio_minute_per = /** @type {((inputs?: Measure_Unit_Audio_Minute_PerInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Unit_Audio_Minute_PerInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_unit_audio_minute_per(inputs)
	if (locale === "pt-BR") return pt_br2_measure_unit_audio_minute_per(inputs)
	if (locale === "es") return es_measure_unit_audio_minute_per(inputs)
	if (locale === "fr") return fr_measure_unit_audio_minute_per(inputs)
	if (locale === "de") return de_measure_unit_audio_minute_per(inputs)
	if (locale === "ru") return ru_measure_unit_audio_minute_per(inputs)
	if (locale === "it") return it_measure_unit_audio_minute_per(inputs)
	return en_measure_unit_audio_minute_per(inputs)
});